import React from "react";
import { Switch, Route } from "react-router-dom";
import { insider } from "routes/paths";
import SignUp from "./SignUp";
import SignUpSuccess from "./SignUpSuccess";
import CallDetail from "./CallDetail";
import Dashboard from "./Dashboard";
import PaymentCallback from "./PaymentCallback";
import Profile from "./Profile";
import Feedback from "./Feedback";
import FeedbackSuccess from "./FeedbackSuccess";
import Referral from "./Referral";
import ReferralSuccess from "./ReferralSuccess";
import InvalidInvitationLink from "./InvalidInvitationLink";
import Reviews from "./Reviews";
import ProfileSetup from "./ProfileSetup";

export default () => (
  <Switch>
    <Route exact path={insider.insiderSignUp} component={SignUp} />
    <Route
      exact
      path={insider.insiderSignUpSuccess}
      component={SignUpSuccess}
    />
    <Route exact path={insider.insiderCallDetails} component={CallDetail} />
    <Route exact path={insider.insiderMain} component={Dashboard} />
    <Route
      exact
      path={insider.insiderPaymentCallback}
      component={PaymentCallback}
    />
    <Route exact path={insider.insiderDashboardProfile} component={Profile} />
    <Route exact path={insider.onCandidateFeedback} component={Feedback} />
    <Route
      exact
      path={insider.insiderFeedbackSuccess}
      component={FeedbackSuccess}
    />
    <Route exact path={insider.insiderReferral} component={Referral} />
    <Route
      exact
      path={insider.insiderReferralSuccess}
      component={ReferralSuccess}
    />
    <Route
      exact
      path={insider.invalidToken}
      component={InvalidInvitationLink}
    />
    <Route exact path={insider.onboarding} component={ProfileSetup} />
    <Route exact path={insider.reviews} component={Reviews} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/index.js